import Header from '../../components/Header';
import Footer from '../../components/Footer/Footer';
import HomeButton from '../../components/Tools/HomeButton/HomeButton';
// import styling
import 'bootstrap/dist/css/bootstrap.min.css';
//import images
import bg from '../../assets/homebg.png';
import SmartInspect from '../../assets/smart-inspect.png';
import Stellantis from '../../assets/STELLANTIS.png';
import Hyundai from '../../assets/HYUNDAI.png';
import GM from '../../assets/GM.png';

// default landing page
const SmartInspectPlants = () => {
	return (
		<>
			<Header home="/" />
			<main class="plant-container" style={{ background: `url(${bg})` }}>
				<wrapper class="home-wrapper" style={{ margin: '0 3vw' }}>
					<HomeButton link="/smart-inspect/warren/login" title="Stellantis (WTAP)" img={Stellantis} />
					<HomeButton link="/smart-inspect/montgomery/overview" title="Hyundai (HMMA)" img={Hyundai} />
					<HomeButton link="/smart-inspect/fort-wayne/login" title="GM (Ft. Wayne)" img={GM} />
					<HomeButton link="/smart-inspect/springhill/login" title="GM (Springhill)" img={GM} />
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SmartInspectPlants;
